import { storePageViewData } from '@corratech/pylot-gtm/src/GTMEvents/storePageViewData'
import { storeCartState } from '@corratech/pylot-gtm/src/GTMEvents/storeCartState'
import { pushCartView } from '@corratech/pylot-gtm/src/GTMEvents/pushCartView'
import { pushPageView } from '@corratech/pylot-gtm/src/GTMEvents/pushPageView'
import { pushPageType } from '@corratech/pylot-gtm/src/GTMEvents/pushPageType'
import { storeUserState } from '@corratech/pylot-gtm/src/GTMEvents/storeUserState'
import {
    pushAddToCart,
    pushRemoveFromCart
} from '@corratech/pylot-gtm/src/GTMEvents/pushCartItemUpdate'
import { pushCheckoutOption } from '@corratech/pylot-gtm/src/GTMEvents/pushCheckoutOption'
import { pushCheckoutStep } from 'stores/ooka_usa_store/components/OOKA/pylot-gtm/src/GTMEvents/pushCheckoutStep'
import { pushOrder } from '@corratech/pylot-gtm/src/GTMEvents/pushOrder'
import { pushPdp } from '@corratech/pylot-gtm/src/GTMEvents/pushPdp'
import {
    pushPdpRelatedProductsView,
    pushPdpUpSellProductsView,
    pushPdpCrossSellProductsView,
    pushPdpAddToCart
} from 'stores/ooka_usa_store/components/OOKA/pylot-gtm/src/GTMEvents/pushPdpProductsView'
import { pushPlp } from '@corratech/pylot-gtm/src/GTMEvents/pushPlp'
import { pushProductClick } from '@corratech/pylot-gtm/src/GTMEvents/pushProductClick'
import { pushPromotionClick } from '@corratech/pylot-gtm/src/GTMEvents/pushPromotionClick'
import { pushPromotionView } from '@corratech/pylot-gtm/src/GTMEvents/pushPromotionView'
import { pushSearch } from '@corratech/pylot-gtm/src/GTMEvents/pushSearch'
import { pushBannerClickView } from '@corratech/pylot-gtm/src/GTMEvents/pushBannerClickView'
import { pushMenuClick } from '@corratech/pylot-gtm/src/GTMEvents/pushMenuClick'
import { pushUserCustomData } from '@corratech/pylot-gtm/src/GTMEvents/pushUserCustomData'
import { pushApplyCoupon } from '@corratech/pylot-gtm/src/GTMEvents/pushApplyCoupon'

export const GTMEvents = {
    CART_VIEW: pushCartView,
    CART_STATE: storeCartState,
    PAGE_VIEW: storePageViewData,
    PAGE_VIEW_DATA: storePageViewData,
    PUSH_PAGE_VIEW: pushPageView,
    PUSH_PAGE_TYPE: pushPageType,
    USER_STATE: storeUserState,
    ADD_TO_CART: pushAddToCart,
    ADD_TO_CART_PDP: pushPdpAddToCart,
    REMOVE_FROM_CART: pushRemoveFromCart,
    CHECKOUT_OPTION: pushCheckoutOption,
    CHECKOUT: pushCheckoutStep,
    PLACE_ORDER: pushOrder,
    PDP: pushPdp,
    PDP_RELATED_PRODUCTS_VIEW: pushPdpRelatedProductsView,
    PDP_UP_SELL_PRODUCTS_VIEW: pushPdpUpSellProductsView,
    PDP_CROSS_SELL_PRODUCTS_VIEW: pushPdpCrossSellProductsView,
    PLP: pushPlp,
    PRODUCT_CLICK: pushProductClick,
    PROMOTION_CLICK: pushPromotionClick,
    PROMOTION_VIEW: pushPromotionView,
    SEARCH: pushSearch,
    BANNER_CLICK: pushBannerClickView,
    MENU_CLICK: pushMenuClick,
    GET_USER_DATA: pushUserCustomData,
    APPLY_COUPON: pushApplyCoupon
}
